import { Checkbox } from "@website/ui/checkbox";
import { MiniChips } from "@website/ui/mini-chips";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { FilterCollapse } from "@website/widget/filter/collapse";
import { CheckboxTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { Fragment } from "react";

interface CheckboxFilterProperties extends CheckboxTypes {
  name: string;
  collapseClassName?: string;
  containerClassName?: string;
}

export const CheckboxFilter = (properties: CheckboxFilterProperties) => {
  const {
    name,
    title,
    collapsible,
    options = [],
    isNew = false,
    showTitle = true,
    collapseClassName,
    containerClassName,
    onChange
  } = properties;
  const router = useRouter();

  const { [name]: value } = router.query as Record<string, string>;

  const valueArray = toString(value).split(",").filter(Boolean);

  function isChecked(option: string) {
    return valueArray.includes(option);
  }

  function _onChange(label: string, option: string) {
    return function ({
      target: { checked }
    }: {
      target: { checked: boolean };
    }) {
      router.replace(
        {
          query: deepOmit(
            {
              ...router.query,
              ...(checked
                ? {
                    [name]: [...valueArray, option].join(",")
                  }
                : {
                    [name]: valueArray.filter((op) => op !== option)
                  })
            },
            isFilled
          )
        },
        undefined,
        { shallow: true, scroll: false }
      );

      onChange?.({ name: option, label, isChecked: checked });
    };
  }

  return (
    <Fragment>
      <div className="inline-grid grid-cols-2 items-center gap-2">
        {showTitle && <span className={styles["filter-header"]}>{title}</span>}
        {isNew && (
          <MiniChips color="primary" text="جدید" variant="round-contained" />
        )}
      </div>
      <FilterCollapse
        active={collapsible}
        className={collapseClassName}
        containerClassName={containerClassName}
      >
        {options.map((option) => (
          <div
            className={styles["filter-checkbox-container"]}
            key={name + option.name}
          >
            <Checkbox
              checked={isChecked(option.name)}
              className={styles["filter-checkbox"]}
              color="secondary"
              label={option.label}
              onChange={_onChange(option.label, option.name)}
              name={option.name}
            />
            {option.icon}
          </div>
        ))}
      </FilterCollapse>
    </Fragment>
  );
};
